import { render, staticRenderFns } from "./IconPhoneSolid.vue?vue&type=template&id=23b736ec"
import script from "./IconPhoneSolid.vue?vue&type=script&lang=js"
export * from "./IconPhoneSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports